const FAPP_DOCUMENT_CODE_PATTERN = /^FAPP-0[1-8](?:\b|\s)/i;

export const shouldAutoSaveDocumentForm = (documentCode = '') => (
  !FAPP_DOCUMENT_CODE_PATTERN.test(String(documentCode).trim())
);
